import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { INotification } from 'src/models/notification.model';
import services from 'src/services/notification.service';

export const actionTypes = {
  NOTIFICATION_FETCH: 'NOTIFICATION_FETCH',
  NOTIFICATION_COUNT: 'NOTIFICATION_COUNT',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.NOTIFICATION_FETCH,
    service: services.listGET,
    meta: { error: false },
  },
  countGET: {
    type: actionTypes.NOTIFICATION_COUNT,
    service: services.countGET,
    meta: { error: false },
  },
};

export type INotificationsAsync = typeof asyncActions;

export interface INotificationsState extends ICommonState<INotificationsAsync> {
  data?: INotification;
  list: INotification[];
  total: number;
  count: number;
}

export const defaultState: INotificationsState = {
  status: {},
  list: [],
  total: 0,
  count: 0,
};

const NotificationsReducer = (
  state: INotificationsState = defaultState,
  action: IReducerAction<INotificationsAsync>
): INotificationsState => {
  switch (action.type) {
    case actionTypes.NOTIFICATION_FETCH: {
      return {
        ...state,
        list: action.payload?.notifications.rows ?? [],
      };
    }

    case actionTypes.NOTIFICATION_COUNT: {
      return {
        ...state,
        count: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default NotificationsReducer;
